import { render } from "./LinkSerializer.vue?vue&type=template&id=fe6a281c"
import script from "./LinkSerializer.vue?vue&type=script&lang=js"
export * from "./LinkSerializer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__